import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import bannerVdi from "../../images/banners/banner_vdi.png";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";

const VDIWindows11Page = (props) => {
  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> VDI Windows 11
                      </span>
                      <h2 className="title">
                        Workstations virtuais de alta performance acessíveis de
                        qualquer lugar
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerVdi} alt="VDI Windows 11 Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  VDI Windows 11 Somar: O Futuro do Trabalho Remoto
                </h2>
                <p className="sd-content">
                  A solução VDI (Virtual Desktop Infrastructure) Windows 11 da
                  SOMAR Cloud revoluciona a forma como sua equipe trabalha,
                  oferecendo workstations virtuais de alta performance
                  acessíveis de qualquer dispositivo e localização. Com Windows
                  11 Enterprise otimizado, GPU dedicada NVIDIA e conectividade
                  ultra-rápida, proporcionamos uma experiência desktop idêntica
                  ao local, mas com toda a flexibilidade da nuvem.
                </p>
                <br />
                <p className="sd-content">
                  Nossa infraestrutura VDI suporta aplicações gráficas
                  intensivas como CAD, renderização 3D, edição de vídeo e
                  desenvolvimento de games, mantendo performance nativa mesmo
                  remotamente. Com tecnologia Citrix HDX e protocolos
                  otimizados, eliminamos latências e garantimos responsividade
                  em tempo real para qualquer tipo de aplicação profissional.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Diferenciais exclusivos Somar:</strong> GPU
                  virtualizada NVIDIA vGPU, perfis de usuário persistentes,
                  integração com Active Directory, políticas de segurança
                  centralizadas, backup automático de sessões, e acesso
                  multiplataforma (Windows, Mac, iOS, Android). Transforme
                  qualquer dispositivo em uma workstation empresarial poderosa.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Implementação VDI Enterprise</h2>
                <p className="sd-content">
                  Nossa metodologia de implementação VDI garante transição suave
                  com preservação de perfis, aplicações e produtividade da
                  equipe.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Assessment de Aplicações</h3>
                  <p className="xb-item--contact">
                    Análise de compatibilidade e requisitos de performance.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Design de Infraestrutura</h3>
                  <p className="xb-item--contact">
                    Arquitetura VDI otimizada para suas cargas de trabalho.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Migração de Perfis</h3>
                  <p className="xb-item--contact">
                    Transferência completa de dados e configurações de usuário.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Suporte Contínuo</h3>
                  <p className="xb-item--contact">
                    Gestão proativa e otimização de performance VDI.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Vantagens do VDI Windows 11</h2>
                  <p className="sd-content">
                    Potencialize a produtividade da sua equipe com workstations
                    virtuais de última geração, oferecendo flexibilidade total
                    sem comprometer performance ou segurança.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Windows 11 Enterprise com licenciamento incluído
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      GPU dedicada NVIDIA para aplicações gráficas
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Acesso multiplataforma e responsivo
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Perfis de usuário persistentes e seguros
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Integração completa com Active Directory
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Backup automático de sessões e dados
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Políticas de segurança centralizadas
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Suporte para aplicações CAD e 3D
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default VDIWindows11Page;
